module.exports = __webpack_public_path__ + "static/media/b-sci-major-21_LR.3dd89520.jpg";